(function(){
     'use strict';

     angular
        .module('app')
        .factory('StripeService', StripeService);

    StripeService.$inject = ['$uibModal', 'PedidoService','$http'];

    function StripeService($uibModal, PedidoService, $http){


        var stripe = Stripe('pk_live_51JyyOOFij7eyvD3ptHFa41AWcg30R3zvTJcQErpSNZ5GiZoxikBGniYHwEJPsVE14ya4BaC9h9Je0IHY6h1yOamm00LJoJFLyQ' , { locale: 'en'} );
        //var stripe = Stripe('pk_test_51JyyOOFij7eyvD3pdzurdd3YHPcrTGqB5kShK0rBH53EzYqeIRFf6Ap5u2vIGXS4rD4dj6z5JyZnOB1nVc4Cn3Mt00UDjNgs33' , { locale: 'en'} );
        //var stripe = Stripe('sk_test_51JyyOOFij7eyvD3pX9vsYJBQe2eJ31pPQ851263vqtDdLY9f1OIHZC9X7qZiERWfI6fl491pKf2pxuKCQc1tlntj00JJxItqrd' , { locale: 'en'} );
        var card  = null;
        var elements = null;
        /*
        https://stripe.com/docs/testing
        No authentication (default U.S. card): 4242 4242 4242 4242.
        Authentication required: 4000 0027 6000 3184.
        */
        var vm = {
            loading:false,
            amount:0,
            description:'',
            //items:[],
            product_id : false,
            fullname: "",
            pedido:false,
            error:false,
            errorMsg:"",
            products:{},
            document_id:null,
            cupon:null

        };

        vm.clear = function(){
            vm.products = {};
            vm.amount = 0;
            vm.fullname = '';
            vm.init();
        };

        vm.setAmount=function(amount)
        {
            vm.amount = amount;
        };

        vm.setDescription=function(description)
        {
            vm.description = description;
        };
         vm.setProductId=function(product_id)
        {
            vm.product_id = product_id;
        };

        vm.addProduct = function(key,amount)
        {
            if(amount>0)
                vm.products[key]= amount;
        };

        vm.setProducts = function(products)
        {
            angular.forEach(products,function(value,key){
                if(value>0)
                  vm.products[key]= value;
            });
        };


        vm.init = function()
        {
            elements = stripe.elements();
            var style = {
                    base: {
                    // Add your base input styles here. For example:
                        lineHeight: '1.429'
                    },
            };
            // Create an instance of the card Element.
            card = elements.create('card', {style: style});
            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');
        };

        

        vm.submitForm = function(valid,callback,callbackerr)
        {       
          if(vm.loading==false){ 
             vm.loading = true;
            var config = {
                headers : {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                        'Cache-Control' : 'no-cache'
                }
            };

            var data = $.param({
                amount:vm.amount,
                description:vm.description,
                lang_id:lang_id
            });
                   return  $http.post('/ajax/payment', data, config)
                        .then(function(data){

                            return stripe.confirmCardPayment(data.data.clientSecret, {
                                  payment_method: {
                                    card: card
                                  }
                            }).then(function(result) {
                                //console.log("result",result);
                                  if (result.error) {
                                        // Show error to your customer
                                        //showError(result.error.message);
                                        vm.error =  true;
                                        vm.errorMsg =  result.error.code;
                                        vm.errorMsgEn =  result.error.message;
                                      vm.loading = false;
                                    if(typeof(callbackerr)!='undefined'){

                                        return callbackerr(result);
                                    }else{
                                        return result;
                                    }

                                  } else {
                                      vm.error =  false;
                                    // The payment succeeded!
                                    //orderComplete(result.paymentIntent.id);
                                    return callback(result);
                                  }

                            });
                });
                      }
        };

      
        return vm;
    }
})();